@if (addNewAddress) {
  <dcp-company-new-address [company]="company" (cancel)="addNewAddress = false"></dcp-company-new-address>
} @else {
  <h3 class="heading__regular--xs udex-mb-20">
    {{'registration.addressSelection.heading' | cxTranslate}}
  </h3>
  <p class="body--m text-grey udex-mb-20"
     [innerHtml]="'registration.addressSelection.subheading' | cxTranslate: {companyName: company?.displayName}">
  </p>
  <udex-select-box
    label="Address"
    class="d-block udex-mb-20"
    mode="SingleSelect"
    search-placeholder="Address"
    height="200px"
    [accessibleName]="'registration.searchPlaceholder' | cxTranslate"
    required
    [disabled]="inProgress"
    (selection-change)="registerUser(company?.addresses[$event.detail.item.dataset.index])">
    @for (address of company?.addresses; track $index) {
      <udex-select-box-item
        [label]="formatAddress(address)"
        [attr.data-cy]="company.displayName"
        [attr.data-index]="$index">
      </udex-select-box-item>
    }
  </udex-select-box>

  <p class="body--xs text-blue-gray udex-mb-20" data-cy="create-new-btn">
    {{'registration.addressSelection.createNew1' | cxTranslate}}<br>
    {{'registration.addressSelection.createNew2' | cxTranslate}}
    <udex-link
      class="body--xs"
      (click)="addNewAddress = true"
      data-cy="create-new-organization-link"
      design="Default">
      {{'registration.addressSelection.createNew3' | cxTranslate}}
    </udex-link>
  </p>

  <udex-button
    size="Large"
    design="Secondary"
    data-cy="back-btn"
    (click)="companyChange.emit()">
    {{'common.back' | cxTranslate}}
  </udex-button>
}
